import { Flex, FlexProps, Skeleton } from 'antd';
import clsx from 'clsx';
import { FC } from 'react';

import styles from './styles.module.scss';

interface ICustomCardProps extends FlexProps {
    isLoading?: boolean;
}

export const CustomCard: FC<ICustomCardProps> = ({ className, isLoading, ...props }) => {
    return (
        <Flex className={clsx(styles.card, className)} vertical {...props}>
            {isLoading ? <Skeleton active /> : props.children}
        </Flex>
    );
};
